(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bd-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.bdc');
  if (!root) return;
  var grid = root.querySelector('#bdcGrid');
  var cards = Array.prototype.slice.call(root.querySelectorAll('.pcard'));
  var promos = Array.prototype.slice.call(root.querySelectorAll('.promo-tile'));
  var initialOrder = Array.prototype.slice.call(grid.children);
  var catBtns = root.querySelectorAll('.fcat[data-cat]');
  var sampleBtns = root.querySelectorAll('.fcat[data-sample]');
  var consultBtns = root.querySelectorAll('.fcat[data-consult]');
  var sortSel = root.querySelector('#bdcSort');
  var countEl = root.querySelector('#bdcCount');
  var emptyEl = root.querySelector('.col-empty');
  var cur = '__all__';
  var q = '';
  var searchInput = root.querySelector('#bdcSearch');
  var allBtns = [].concat([].slice.call(catBtns), [].slice.call(sampleBtns), [].slice.call(consultBtns));
  function handleOf(b) { return b.dataset.cat || b.dataset.sample || b.dataset.consult || '__all__'; }

  // 每張卡的可搜尋文字（名稱＋描述＋分類小標），小寫化一次備用
  cards.forEach(function (card) {
    var t = card.querySelector('h3'); var d = card.querySelector('.pdesc'); var c = card.querySelector('.pcard-cat');
    card._txt = ((t ? t.textContent : '') + ' ' + (d ? d.textContent : '') + ' ' + (c ? c.textContent : '')).toLowerCase();
  });

  // sample handle -> label, 用於在卡片上補樣本標籤（側欄=按鈕、pills=檢測類型 checkbox）
  var sampleMap = {};
  sampleBtns.forEach(function (b) { if (b.dataset.sample !== '__all__') sampleMap[b.dataset.sample] = b.textContent.trim(); });
  root.querySelectorAll('input[data-sample-cb]').forEach(function (c) {
    sampleMap[c.getAttribute('data-sample-cb')] = c.parentNode.textContent.trim();
  });
  function sampleClass(label) {
    if (label.indexOf('血') !== -1) return ' tag--blood';
    if (label.indexOf('尿') !== -1) return ' tag--urine';
    if (label.indexOf('糞') !== -1 || label.indexOf('便') !== -1) return ' tag--stool';
    return '';
  }
  cards.forEach(function (card) {
    var cols = card.getAttribute('data-cols') || '';
    var html = '', labels = [];
    Object.keys(sampleMap).forEach(function (h) {
      if (cols.indexOf('|' + h + '|') !== -1) {
        html += '<span class="tag' + sampleClass(sampleMap[h]) + '">' + sampleMap[h] + '</span>';
        labels.push(sampleMap[h]);
      }
    });
    var meta = card.querySelector('.pcard-meta');
    if (meta) meta.innerHTML = html;
    // 標題上方小字：「核心檢測 · 血液 · 含顧問解說」（類型 · 樣本 · 後綴）
    var sub = card.querySelector('.pcard-sub');
    if (sub) {
      var parts = [];
      if (sub.textContent.trim()) parts.push(sub.textContent.trim());
      parts = parts.concat(labels);
      var sfx = card.getAttribute('data-sub-suffix');
      if (sfx) parts.push(sfx);
      sub.textContent = parts.join(' · ');
    }
  });

  // 檢測類型（樣本）多選 checkbox（pills 版面）
  var sampleCbs = Array.prototype.slice.call(root.querySelectorAll('input[data-sample-cb]'));
  var sampleSel = [];
  var ttWrap = root.querySelector('#bdcTT');
  var ttCount = root.querySelector('[data-tt-count]');
  function syncSamples() {
    sampleSel = sampleCbs.filter(function (c) { return c.checked; }).map(function (c) { return c.getAttribute('data-sample-cb'); });
    if (ttCount) ttCount.textContent = sampleSel.length ? sampleSel.length : '';
  }

  function matches(card) {
    if (q && card._txt.indexOf(q) === -1) return false;
    var cols = card.getAttribute('data-cols') || '';
    if (sampleSel.length) {
      var hit = false;
      for (var i = 0; i < sampleSel.length; i++) { if (cols.indexOf('|' + sampleSel[i] + '|') !== -1) { hit = true; break; } }
      if (!hit) return false;
    }
    if (cur === '__all__') return true;
    return cols.indexOf('|' + cur + '|') !== -1;
  }
  function updateCounts() {
    var allBtn = root.querySelector('[data-count-all]');
    if (allBtn) allBtn.textContent = cards.length;
    root.querySelectorAll('.fc-n[data-count]').forEach(function (el) {
      var h = el.getAttribute('data-count'); var n = 0;
      cards.forEach(function (c) { if ((c.getAttribute('data-cols') || '').indexOf('|' + h + '|') !== -1) n++; });
      el.textContent = n;
    });
  }
  function render() {
    var shown = 0;
    cards.forEach(function (c) { var v = matches(c); c.style.display = v ? '' : 'none'; if (v) shown++; });
    if (countEl) countEl.textContent = shown;
    if (emptyEl) emptyEl.hidden = shown !== 0;
    promos.forEach(function (p) { p.style.display = (shown === 0 || q) ? 'none' : ''; });
    updateCounts();
  }
  function sortCards(mode) {
    if (mode === 'rec') {
      // 推薦排序＝還原初始 DOM 順序（廣告磚回到原位）
      initialOrder.forEach(function (el) { grid.appendChild(el); });
      return;
    }
    var arr = cards.slice();
    if (mode === 'plow') arr.sort(function (a, b) { return (+a.dataset.price) - (+b.dataset.price); });
    else arr.sort(function (a, b) { return (+b.dataset.price) - (+a.dataset.price); });
    // flagship 永遠置頂
    arr.sort(function (a, b) { return (b.classList.contains('flagship') ? 1 : 0) - (a.classList.contains('flagship') ? 1 : 0); });
    arr.forEach(function (c) { grid.appendChild(c); });
    promos.forEach(function (p) { grid.appendChild(p); });
    if (emptyEl) grid.appendChild(emptyEl);
  }
  // 單選：點任一個就切換，其餘全部取消；再點同一個(非全部)則回到全部
  var allCatBtn = root.querySelector('.fcat[data-cat="__all__"]');
  function selectBtn(b) {
    var h = handleOf(b);
    if (h !== '__all__' && b.classList.contains('sel')) { h = '__all__'; }
    cur = h;
    allBtns.forEach(function (x) { x.classList.remove('sel'); });
    if (cur === '__all__') { if (allCatBtn) allCatBtn.classList.add('sel'); }
    else { b.classList.add('sel'); }
    render();
  }
  allBtns.forEach(function (b) { b.addEventListener('click', function () { selectBtn(b); }); });
  if (searchInput) searchInput.addEventListener('input', function () { q = searchInput.value.trim().toLowerCase(); render(); });
  if (sortSel) sortSel.addEventListener('change', function () { sortCards(sortSel.value); render(); });
  var ft = root.querySelector('#bdcFilterToggle');
  if (ft) ft.addEventListener('click', function () { root.querySelector('#bdcFilterBody').classList.toggle('open'); });
  // 檢測類型下拉：開合 + checkbox 篩選
  sampleCbs.forEach(function (c) { c.addEventListener('change', function () { syncSamples(); render(); }); });
  if (ttWrap) {
    var ttBtn = ttWrap.querySelector('.tt-btn');
    ttBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = ttWrap.classList.toggle('open');
      ttBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    ttWrap.querySelector('.tt-panel').addEventListener('click', function (e) { e.stopPropagation(); });
    document.addEventListener('click', function () { ttWrap.classList.remove('open'); ttWrap.querySelector('.tt-btn').setAttribute('aria-expanded', 'false'); });
  }
  // 格狀 / 列表檢視切換
  var vtBtns = Array.prototype.slice.call(root.querySelectorAll('.vt-btn'));
  vtBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      vtBtns.forEach(function (x) { x.classList.toggle('is-active', x === b); });
      root.classList.toggle('bdc--list', b.getAttribute('data-view') === 'list');
    });
  });
  syncSamples();
  render();
})();

  } catch(e) { console.error(e); }
})();
})();
